import Api from '@/services/Api'

export default {
    add(id, data) {
      return Api().post(`campaigns/${id}/groups-of-discounts`, data).then(function (response) {
        return (response)
      })
    },
    get(id) {
        return Api().get(`campaigns/${id}/groups-of-discounts`).then(function (response) {
            return (response)
          })
    },
    getById(id) {
        return Api().get(`groups-of-discounts/${id}`).then(function (response) {
            return (response)
          })
    },
    partialUpdate(id, data) {
        return Api().patch(`groups-of-discounts/${id}`, data).then(function (response) {
            return (response)
          })
    }
}
